module.exports = __webpack_public_path__ + "static/media/Maupal_figure2.5eab0521.png";